import React from 'react';

export default function ScheduleSection({
    schedule,
    dayLabels,
    onToggleDay,
    onPickTime,
    className,
}) {
    console.log(schedule.reduce((acc, s) => acc + (s.enabled ? 1 : 0), 0))
    return (
        <section className={['shop-create-section', className].filter(Boolean).join(' ')}>
            <div className="shop-create-label">График работы {schedule.reduce((acc, s) => acc + (s.enabled ? 1 : 0), 0) === 0
                    ? <b style={{ color: 'red' }}>*</b>
                    : <b style={{ color: 'green' }}>✅</b>}
            </div>
            {/* <div className="shop-create-help">
                Формат: {`[{ day: 1, open: "09:00", close: "17:00" }, ...]`}
            </div> */}

            <div className="shop-create-schedule">
                {schedule.map((s) => (
                    <div
                        className={[
                            'shop-create-scheduleRow',
                            s.enabled ? '' : 'shop-create-scheduleRowDisabled',
                        ].join(' ')}
                        key={s.day}
                    >
                        <label className="shop-create-dayPick">
                            <input
                                className="shop-create-dayCheckbox"
                                type="checkbox"
                                checked={!!s.enabled}
                                onChange={(e) => onToggleDay(s.day, e.target.checked)}
                            />
                            <span className="shop-create-dayText">
                                {dayLabels[s.day]}{' '}
                            </span>
                        </label>

                        <button
                            className="shop-create-timeButton"
                            type="button"
                            disabled={!s.enabled}
                            onClick={() => onPickTime(s.day)}
                        >
                            {s.open} - {s.close}
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
}

